import { render, staticRenderFns } from "./warnType.vue?vue&type=template&id=6cdec2cd&scoped=true"
import script from "./warnType.vue?vue&type=script&lang=js"
export * from "./warnType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdec2cd",
  null
  
)

export default component.exports